<script lang="ts" setup>
import { sdIconProps } from './icon'
import { computed    } from 'vue'

import SvgIcon     from './SvgIcon.vue'
import FontIcon    from './FontIcon.vue'
import IconifyIcon from './IconifyIcon.vue'

defineOptions({ name: 'SdIcon' })
const props = defineProps(sdIconProps)

const isSvgIcon$ = computed(() => {
    return props.name?.endsWith('|svg')
})

const svgIconName$ = computed(() => {
    return isSvgIcon$.value ? props.name?.replace('|svg', '') : ''
})

const isIconify$ = computed(() => {
    return props.name?.includes(':')
})

</script>

<template>
    <IconifyIcon v-if="isIconify$" 
        :name="props.name"
        :size="props.size"
        :color="props.color"
        :inline="props.inline"
    />

    <SvgIcon v-else-if="isSvgIcon$" 
        :prefix="props.prefix"
        :name="svgIconName$"
        :size="props.size"
        :color="props.color"
    />

    <FontIcon v-else 
        :prefix="props.prefix"
        :name="props.name"
        :color="props.color"
        :size="props.size"
    />
</template>
